/**
 * The page's address as Google Analytics may see it.
 *
 * A shared schedule's URL is its key (`/s/<token>`: anyone holding it can
 * read the schedule), and the login callback arrives with a one-time `code`.
 * GA's first page view sends the full address, so both are taken out first:
 * the token becomes "shared", and `code` and `state` go.
 *
 * GA4's own "page changes based on browser history" measurement, if it is on
 * for this property, reads the address itself on later route changes. None
 * of those lead to a /s/ page (share links arrive from outside), so the first
 * page view is the one that matters.
 */
export function gaPageLocation(href: string = window.location.href): string {
  const url = new URL(href);
  const base = import.meta.env.BASE_URL.replace(/\/+$/, '');
  if (url.pathname.startsWith(`${base}/s/`)) url.pathname = `${base}/s/shared`;
  url.searchParams.delete('code');
  url.searchParams.delete('state');
  return url.href;
}
